import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-foreground-600 text-sm">我们为你精心挑选的优质影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((card, idx) => (
            <div
              key={idx}
              className="rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-accent-200/60 transition-colors cursor-pointer group"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}